// import templateCompiler from './template.art';
// import { Fill_Sign_MAP } from '../constants/fill_sign.constants';

// const template = templateCompiler(Fill_Sign_MAP);
export default function FillAndSignModule() {
  // let target = 'sign-certify-dropdown'
  // let fragments;
  // let ACTIONS = window.UIExtension.UIConsts.FRAGMENT_ACTION;

  let fragments = [
  ];
  return { fragments };
}
